import * as React from "react";
import { CircleUserRound as UserIcon } from "lucide-react";

import type { GridPayload } from "../grid-settings/types";
import ListTable from "./components/table";
import ListContainer from "./components/container";
import ListHeader from "./components/header";

export type ListProps = {
  gridSettingPayload: GridPayload;
  isLeftExpanded: boolean;
  handleSettingClick: () => void;
  handleExpandClick: () => void;
  onCreateExample: () => void;
  onViewExample: (exampleId: string) => void;
  onEditExample: (exampleId: string) => void;
  onDeleteExample: (exampleId: string) => void;
  selectedRowId?: string;
  onTableReady?: (table: unknown) => void;
  children?: React.ReactNode;
};

const List: React.FC<ListProps> = ({
  isLeftExpanded,
  handleSettingClick,
  handleExpandClick,
  onTableReady,
  children
}) => {
  return (
    <ListContainer className="flex flex-col bg-white shadow-lg" isLeftExpanded={isLeftExpanded}>
      <ListHeader
        title="Previous Example"
        isExpanded={isLeftExpanded}
        onSettingClick={handleSettingClick}
        onExpandClick={handleExpandClick}
        titleIcon={<UserIcon className="h-6 w-6 text-white" />}
      />

      <div className="flex h-full">
        <ListTable onTableReady={onTableReady}>{children}</ListTable>
      </div>
    </ListContainer>
  );
};

export default List;
